import type {
  CustomerReportSummaryDto,
  ListCustomerReportsResponse,
  ReportCategory,
  ReportSeverity,
  ReportStatus,
  UpdateCustomerReportRequest,
} from '@bhops/shared';
import { apiClient } from './client';
import { downloadBlob } from './download';

export interface ListReportsQuery {
  status?: ReportStatus;
  severity?: ReportSeverity;
  category?: ReportCategory;
  robotId?: string;
  assignedToId?: string;
  assignedToMe?: boolean;
  openOnly?: boolean;
  // data-lifecycle §3 (PR-5b) — 삭제됨 포함(삭제 권한 역할 전용; 서버에서 확인).
  includeDeleted?: boolean;
  page?: number;
  pageSize?: number;
}

export const reportsApi = {
  async list(query: ListReportsQuery = {}): Promise<ListCustomerReportsResponse> {
    const { data } = await apiClient.get<ListCustomerReportsResponse>('/reports', {
      params: query,
    });
    return data;
  },
  async get(id: string): Promise<CustomerReportSummaryDto> {
    const { data } = await apiClient.get<CustomerReportSummaryDto>(`/reports/${id}`);
    return data;
  },
  async update(id: string, body: UpdateCustomerReportRequest): Promise<CustomerReportSummaryDto> {
    const { data } = await apiClient.patch<CustomerReportSummaryDto>(`/reports/${id}`, body);
    return data;
  },
  async exportCsv(query: ListReportsQuery = {}): Promise<void> {
    await downloadBlob('/reports/export.csv', query, 'reports.csv');
  },
  // data-lifecycle §3/D3 (PR-5b) — 셀프 소프트삭제(deletedAt 스탬프).
  async softDelete(id: string): Promise<{ id: string; deletedAt: string | null }> {
    const { data } = await apiClient.delete<{ id: string; deletedAt: string | null }>(
      `/reports/${encodeURIComponent(id)}`,
    );
    return data;
  },
  // soft-delete 복구(셀프).
  async restore(id: string): Promise<{ id: string; deletedAt: string | null }> {
    const { data } = await apiClient.post<{ id: string; deletedAt: string | null }>(
      `/reports/${encodeURIComponent(id)}/restore`,
    );
    return data;
  },
  // 셀프 완전삭제(소프트삭제된 리포트만, FK 가드).
  async hardDelete(id: string): Promise<{ id: string; deleted: true }> {
    const { data } = await apiClient.delete<{ id: string; deleted: true }>(
      `/reports/${encodeURIComponent(id)}/permanent`,
    );
    return data;
  },
};
